export default __webpack_public_path__ + "media/images/floppy-disk-45ad2976.svg";